module.exports = __webpack_public_path__ + "img/4.c2cc6f6a.png";